export const getTokenFromLocalStorage = () => {
	if (typeof(Storage) !== "undefined") {
		return localStorage.getItem("bac_token")
	} else {
		return ''
	}
}

export const clearTokenFromLocalStorage = () => {
	if (typeof(Storage) !== "undefined") {
		return localStorage.setItem("bac_token", "")
	} else {
		return ''
	}
}

export const setTokenFromLocalStorage = (token) => {
	if (typeof(Storage) !== "undefined") {
		return localStorage.setItem("bac_token", token)
	} else {
		return ''
	}
}

export const hasTokenFromLocalStorage = () => {
	if (typeof(Storage) !== "undefined") {
		return localStorage.getItem("bac_token") !== ''
	} 
	return false
}



// WEBPACK FOOTER //
// ./src/helpers/token.js